<div class="input-container">
    <nz-input-group class="select-style" *ngIf="type === 'input'">
        <input
            type="text"
            nz-input
            trim="blur"
            [(ngModel)]="value"
            [placeholder]="placeholder"
            [disabled]="!canEdit"
            (ngModelChange)="changeValue()"
        />
    </nz-input-group>
    <label nz-checkbox [(ngModel)]="value" *ngIf="type === 'checkbox'"
           [nzDisabled]="!canEdit" (ngModelChange)="changeValue()">{{text}}</label>
    <nz-select
        *ngIf="type === 'select'"
        style="width: 100%"
        [(ngModel)]="value"
        (ngModelChange)="changeValue()"
        [nzDisabled]="!canEdit"
        [nzShowArrow]="nzShowArrow"
        [nzAllowClear]="nzAllowClear"
    >
        <nz-option
            *ngFor="let option of selectOptions"
            [nzLabel]="option.label"
            [nzValue]="option.value"
        ></nz-option>
    </nz-select>
    <nz-input-number
        [(ngModel)]="value"
        (ngModelChange)="changeValue()"
        *ngIf="type === 'inputNumber'"
        [nzMin]="min"
        [nzDisabled]="!canEdit"
        [placeholder]="placeholder"
    ></nz-input-number>
    <nz-switch
        *ngIf="type === 'switch'"
        [(ngModel)]="value"
        (ngModelChange)="changeValue()"
    ></nz-switch>
</div>
